import { render, staticRenderFns } from "./showOnlyEn.vue?vue&type=template&id=40ed57e2"
var script = {}
import style0 from "./showOnlyEn.vue?vue&type=style&index=0&id=40ed57e2&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/TypXw3yGP/0/DHCCorporation/dhc-cloud-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40ed57e2')) {
      api.createRecord('40ed57e2', component.options)
    } else {
      api.reload('40ed57e2', component.options)
    }
    module.hot.accept("./showOnlyEn.vue?vue&type=template&id=40ed57e2", function () {
      api.rerender('40ed57e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/showOnlyEn.vue"
export default component.exports